module.exports = __webpack_public_path__ + "img/pick5.6d2a5e99.png";